(function () {
  /**
   * Site Built by iamota
   */
  var builtByIamota = {
    message: ['%c                                                            ', '%c Site designed & built by %ciamota                            ', '%c A leading %cShopify Plus%c Design & Development Agency Partner ', '%c                                                            ', '%c Contact us at %chello@iamota.com%c or www.iamota.com           ',
    //'%c                                              iamotaQuiz(); ',
    '%c                                                            '].join('\n'),
    styles: ['background: #333; color: #fff; font-size: 16px;', 'background: #333; color: #f9c992; font-size: 16px;', 'background: #333; color: #f9c992; font-size: 16px; font-style: italic;', 'background: #333; color: #fff; font-size: 16px; font-style: italic;', 'background: #f9c992; color: #333; font-size: 16px;', 'background: #f9c992; color: #fff; font-size: 16px;', 'background: #f9c992; color: #7d5d3b; font-size: 16px;', 'background: #333; color: #444; font-size: 16px;']
  };
  console.log(builtByIamota.message, builtByIamota.styles[0], builtByIamota.styles[0], builtByIamota.styles[2], builtByIamota.styles[3], builtByIamota.styles[2], builtByIamota.styles[3], builtByIamota.styles[0], builtByIamota.styles[4], builtByIamota.styles[6], builtByIamota.styles[4], builtByIamota.styles[7]);

  // /**
  //  * iamota Developer Quiz
  //  */
  // const iamotaQuiz = {
  //     currentQuestion: 0,
  //     score: 0,
  //     initialized: false,
  //     questions: [
  //         {
  //             question: 'Question 1. How can you paginate a collection in Shopify Liquid?',
  //             options: [
  //                 '{% paginate collection.products by 10 %}',
  //                 '{% for product in collection.products limit: 10 %}',
  //                 '{% assign pages = collection.products | paginate: 10 %}',
  //                 '{% for product in collection.products | slice: 0, 10 %}'
  //             ],
  //             answer: 1
  //         },
  //         {
  //             question: 'Question 2. Which CSS Grid property defines the number of columns in a grid?',
  //             options : ['grid-template-rows', 'grid-template-columns', 'grid-area', 'grid-gap'],
  //             answer  : 2
  //         },
  //         {
  //             question: 'Question 3. How do you define a CSS variable?',
  //             options : ['--main-color: #06c;', 'var(--main-color)', 'main-color: #06c;', 'var(main-color)'],
  //             answer  : 1
  //         },
  //         {
  //             question: 'Question 4. Which attribute is essential for screen readers to describe images?',
  //             options : ['title', 'src', 'alt', 'aria-label'],
  //             answer  : 3
  //         },
  //         {
  //             question: 'Question 5. Which method is used to define a custom element in JavaScript Web Components?',
  //             options : ['defineCustomElement', 'customElement.define', 'customElements.define', 'element.define'],
  //             answer  : 3
  //         }
  //     ],

  //     explosionAnimation: (completedCallback) => {
  //         const frames = 20;
  //         const lines  = 20;
  //         const colors = ['#7d5d3b', '#f9c992', '#b87d4b', '#ffdbac', '#a67c5b'];
  //         const width  = 50;

  //         for (let i = 0; i < frames; i++) {
  //             setTimeout(() => {
  //                 console.clear();
  //                 let frameContent = '';
  //                 let styleArray = [];

  //                 for (let j = 0; j < lines; j++) {
  //                     let line = '';
  //                     for (let k = 0; k < width; k++) {
  //                         // Calculate distance from the center
  //                         const distanceFromCenter = Math.sqrt(Math.pow(j - lines / 2, 2) + Math.pow(k - width / 2, 2));
  //                         if (distanceFromCenter < i) {
  //                             const color = colors[Math.floor(Math.random() * colors.length)];
  //                             line += '%c*';
  //                             styleArray.push(`background: #333; color: ${color}; font-size: 16px;`);
  //                         } else {
  //                             line += '%c ';
  //                             styleArray.push('background: #333; color: #333; font-size: 16px;');
  //                         }
  //                     }
  //                     frameContent += line + '\n';
  //                 }
  //                 console.log(frameContent, ...styleArray);
  //             }, i * 150);
  //         }

  //         setTimeout(() => {
  //             console.clear();
  //             completedCallback();
  //         }, (frames+1) * 150);
  //     },

  //     submitAnswer: (answer) => {
  //         if (!iamotaQuiz.initialized) {
  //             iamotaQuiz.initialized = true;
  //             console.log('%cWelcome to the secret %ciamota%c Developer Quiz! ✨', 'color: #333; font-size: 16px;', 'color: #7d5d3b; font-size: 16px;', 'color: #333; font-size: 16px;');
  //         }

  //         if (typeof answer !== 'undefined') {
  //             if (answer === iamotaQuiz.questions[iamotaQuiz.currentQuestion].answer) {
  //                 iamotaQuiz.score++;
  //                 console.log('%cCorrect! Well done! 🎉', 'color: #333; font-size: 16px;');
  //                 iamotaQuiz.currentQuestion++;
  //             } else {
  //                 console.log('%cIncorrect. Keep trying, you got this! 💪', 'color: #333; font-size: 16px;');
  //                 return;
  //             }
  //         }

  //         if (iamotaQuiz.currentQuestion < iamotaQuiz.questions.length) {
  //             console.log('');
  //             console.log(`%c${iamotaQuiz.questions[iamotaQuiz.currentQuestion].question}`, 'color: #7d5d3b; font-size: 14px; font-weight: bold;');
  //             iamotaQuiz.questions[iamotaQuiz.currentQuestion].options.forEach((option, index) => {
  //                 console.log(`%c${index + 1}. ${option}`, 'color: #7d5d3b; font-size: 14px;');
  //             });
  //             console.log('');
  //             console.log('%cEnter iamotaQuiz(number) to answer.', 'color: #333; font-size: 14px;');
  //         } else {
  //             iamotaQuiz.explosionAnimation(() => {
  //                 console.log('');
  //                 console.log('%cCongratulations! You\'ve successfully completed the %ciamota%c Developer quiz! 🌟', 'color: #333; font-size: 16px;', 'color: #7d5d3b; font-size: 16px;', 'color: #333; font-size: 16px;');
  //                 console.log('%cCheck out job opportunities at https://www.iamota.com/careers 🚀', 'color: #333; font-size: 16px;');
  //             });
  //         }
  //     }
  // };

  // // Expose the function globally
  // window.iamotaQuiz = iamotaQuiz.submitAnswer;
})();